import { useEffect, useState } from 'react';

import { readingTime } from '@/utility/readingTime';
import { decodeString } from '@/utility/stripHtml';

export const useContentTimeToRead = (content?: string | null) => {
  const [timeToRead, setTimeToRead] = useState<number>();

  useEffect(() => {
    if (!content) return;

    try {
      setTimeToRead(readingTime(decodeString(content)));
    } catch {
      return;
    }
  }, [content]);

  return timeToRead;
};
